import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { H1, P } from './TwoFactorStyledComponents';
import { TwoFactorRecoveryAdmin } from './TwoFactorRecoveryAdmin';
import { TwoFactorRecoveryChoice } from './TwoFactorRecoveryChoice';
import { TwoFactorRecoverySupport } from './TwoFactorRecoverySupport';
import { useContext, useEffect } from 'react';
import { TwoFactorRecoveryContext } from '../../contexts/twoFactorRecovery';
import { TwoFactorRecoverySuccess } from './TwoFactorRecoverySuccess';
import { TwoFactorRecoveryAlerts } from './TwoFactorRecoveryAlerts';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const headerCopy = {
  admin: 'recoveryAdmin.header',
  choice: 'header',
  support: 'recoverySupport.header'
};
export const TwoFactorRecoveryModal = () => {
  const {
    closeTwoFactorRecovery,
    isTokenExpired,
    loadingError,
    ready,
    recoveryAttempted,
    recoverySent,
    setupTwoFactorRecoveryPage,
    twoFactorRecoveryType
  } = useContext(TwoFactorRecoveryContext);
  useEffect(() => {
    setupTwoFactorRecoveryPage();
  }, [setupTwoFactorRecoveryPage]);
  return ready ? /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `reAuth.recovery.${headerCopy[twoFactorRecoveryType || 'choice']}`
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: closeTwoFactorRecovery
      })]
    }), loadingError || isTokenExpired ? /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(P, {
        children: /*#__PURE__*/_jsx(TwoFactorRecoveryAlerts, {})
      })
    }) : recoveryAttempted && recoverySent ? /*#__PURE__*/_jsx(TwoFactorRecoverySuccess, {}) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [twoFactorRecoveryType === 'admin' && /*#__PURE__*/_jsx(TwoFactorRecoveryAdmin, {}), twoFactorRecoveryType === 'choice' && /*#__PURE__*/_jsx(TwoFactorRecoveryChoice, {}), twoFactorRecoveryType === 'support' && /*#__PURE__*/_jsx(TwoFactorRecoverySupport, {})]
    })]
  }) : /*#__PURE__*/_jsx(UIModal, {
    use: "conversational",
    children: /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      minHeight: 100
    })
  });
};